import { get } from 'lodash';
import { connect } from 'react-redux';

import PdpSidebarRecs from 'components/PdpSidebarRecs';
import { CAMPAIGN_NAMES, PERSONALIZATION_STATUS } from 'constants/personalizations';
import BooleanExperimentCampaign from 'models/BooleanExperimentCampaign';
import DYRecommendationsModel from 'models/DYRecommendations';
import * as actions from 'state/actions';
import PersonalizationsSelector from 'state/selectors/personalizations';
import Rudderstack from 'utils/Rudderstack';

let recommendationsData = {};
let additionalRecommendationsExperimentData = {};

const mapStateToProps = state => {
  const campaignData = PersonalizationsSelector.getCampaignByName(
    state,
    CAMPAIGN_NAMES.PDP_SIDEBAR_RECS
  );

  if (campaignData?.status === PERSONALIZATION_STATUS.SUCCESS) {
    recommendationsData = new DYRecommendationsModel(campaignData);
  }

  const metadata = get(recommendationsData, ['_data', 'variations', 0, 'analyticsMetadata']);
  const dyCampaignData = {
    campaignId: metadata?.campaignId,
    campaignName: metadata?.campaignName,
    variationId: metadata?.variationId,
    variationName: metadata?.variationName,
    experienceId: metadata?.experienceId,
    experienceName: metadata?.experienceName,
  };

  // Experiment additional recommendations
  const additionalRecommendationsCampaignData = PersonalizationsSelector.getCampaignByName(
    state,
    CAMPAIGN_NAMES.PDP_ADDITIONAL_RECOMMENDATIONS
  );

  if (additionalRecommendationsCampaignData?.status === PERSONALIZATION_STATUS.SUCCESS) {
    additionalRecommendationsExperimentData = new BooleanExperimentCampaign({
      campaign: additionalRecommendationsCampaignData,
    });
  }

  return {
    heading: recommendationsData.title,
    products: recommendationsData.products,
    showColorway: recommendationsData.showColorway,
    dyCampaignData,
    additionalRecommendationsExperimentData,
  };
};

const mapDispatchToProps = dispatch => ({
  trackEvent: ({ slotId, productName, analyticsProperties }) => {
    dispatch(
      actions.trackDYRecsClick({
        eventCategory: 'PDP',
        eventAction: 'RecsSidebar_click',
        eventLabel: productName,
        slotId,
      })
    );
    Rudderstack.recommendationsClicked({
      ...analyticsProperties,
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PdpSidebarRecs);
